<script lang="ts">
	import { twMerge } from "tailwind-merge";
	import type { ComponentProps } from "#lib/components/page/ComponentProps.js";
	import { stringValue, structValue } from "#lib/struct.js";

	let { id, style, page, children }: ComponentProps = $props();

	const config = $derived(structValue($page.config, id));
	const isHbox = $derived(stringValue(config, "direction") === "col");
	const configClass = $derived(stringValue(config, "class") ?? "");
</script>

<div class={twMerge(`flex w-full min-w-0 flex-${isHbox ? "row" : "col"}`, isHbox && "items-start", configClass)} {style}>
	{@render children?.()}
</div>
